document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
    const el = document.querySelector(a.getAttribute('href'));
    if (el) { e.preventDefault(); el.scrollIntoView({behavior:'smooth'}); }
  }));
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('.hero-slide')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;

    const show = i => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s,n) => {
        const active = n === index;
        s.classList.toggle('is-active', active);
        const wrapper = s.closest('.hero-slide-link');
        if (wrapper) {
          wrapper.style.opacity = active ? '1' : '0';
          wrapper.style.visibility = active ? 'visible' : 'hidden';
          wrapper.style.pointerEvents = active ? 'auto' : 'none';
          wrapper.style.zIndex = active ? '1' : '0';
        }
      });
      dots.forEach((d,n) => d.classList.toggle('is-active', n === index));
    };
    const restart = () => {
      clearInterval(timer);
      timer = setInterval(() => show(index + 1), 6500);
    };

    slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(index - 1); restart(); });
    slider.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(index + 1); restart(); });
    dots.forEach((dot,n) => dot.addEventListener('click', () => { show(n); restart(); }));
    restart();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    menu.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }));
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header-search-form').forEach(form => {
    const input = form.querySelector('.header-search-input');
    const button = form.querySelector('.header-search-submit');
    if (!input || !button) return;

    button.addEventListener('click', (event) => {
      const isOpen = form.classList.contains('is-open');
      if (!isOpen) {
        event.preventDefault();
        form.classList.add('is-open');
        input.focus();
      } else if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
      }
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        form.classList.remove('is-open');
        input.blur();
      }
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target) && !input.value.trim()) {
        form.classList.remove('is-open');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const toEmbedUrl = (url) => {
    if (!url) return '';
    try {
      const u = new URL(url, window.location.origin);
      if (u.hostname.includes('youtu.be')) {
        const id = u.pathname.replace(/^\/+/, '').split('/')[0];
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : '';
      }
      if (u.hostname.includes('youtube.com')) {
        if (u.pathname.startsWith('/embed/')) {
          return u.href + (u.search ? '&' : '?') + 'autoplay=1';
        }
        const id = u.searchParams.get('v') || (u.pathname.startsWith('/shorts/') ? u.pathname.split('/')[2] : '');
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : '';
      }
      if (u.hostname.includes('vimeo.com')) {
        const id = u.pathname.split('/').filter(Boolean).pop();
        return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : '';
      }
    } catch(e) {}
    return url;
  };

  document.querySelectorAll('.footer-video-trigger, .footer-video-text-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const container = trigger.parentElement.querySelector('[data-footer-inline-video]');
      const rawUrl = trigger.dataset.videoUrl || '';
      if (!container || !rawUrl) return;

      const lower = rawUrl.toLowerCase();
      container.hidden = false;

      if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(lower)) {
        container.innerHTML = `<video controls autoplay playsinline><source src="${rawUrl}"></video>`;
      } else {
        const embed = toEmbedUrl(rawUrl);
        container.innerHTML = `<iframe src="${embed}" title="Powercom video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
      }

      trigger.style.display = 'none';
    });
  });
});
